<template>
    <div class="panel">
        <div v-if="this.$slots.title || this.$slots.subtitle" class="panel__header px-4 my-4">
            <p v-if="this.$slots.title" class="title my-0"><slot name="title"></slot></p>
            <h4 v-if="this.$slots.subtitle" class="subtitle my-0"><slot name="subtitle"></slot></h4>
        </div>
        <template v-if="this.$slots.alert">
            <slot name="alert"></slot>
        </template>
        <div v-if="this.$slots.content" class="panel__content px-4 my-4">
            <slot name="content"></slot>
        </div>
        <div v-if="this.$slots.footer" class="panel__footer px-4 my-4">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Panel",
    }
</script>
